export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/oracle.9dd2969.svg";